/* eslint-disable multiline-ternary */
/* eslint-disable array-bracket-newline */
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Tooltip,
} from "reactstrap";
import Select from "react-select";
import { selectThemeColors } from "@utils";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Breadcrumbs from "@components/breadcrumbs";
import {
  defaultValues,
  // animationOption,
  codecOption,
  NELOption,
  compressionOption,
  framesOption,
  // positionOption,
  // whenOption,
} from "./utils";
import { useDispatch, useSelector } from "react-redux";
import {
  editProfileCreate,
  fetchProjectStyleProfile,
  fetchStyleProfile,
} from "../../../redux/styleProfile";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import { ADMIN_ROUTES, USER_ROUTES } from "../../../constant/route";
import { resolutionRegex } from "../../../utility/regex";
import LineSkelaton from "../../../common/skeleton/LineSkelaton";
import { ArrowLeft, Camera, Trash2, X } from "react-feather";
import "react-slidedown/lib/slidedown.css";
import { SlideDown } from "react-slidedown";
import toast from "react-hot-toast";
import ToastContent from "../../components/toast/toast";
import ConfirmModel from "../../components/modals/ConfirmModal";
import Loader from "../../../common/Loader/Loader";
import UILoader from "@components/ui-loader";
import OrderButton from "../../components/orderButton/OrderButton";
import CreateProjectInfoModel from "../myprojects/myProjectsModels/CreateProjectInfoModel";

const schema = yup.object({
  // camera_model: yup.string().required("Camera Model  is Required"),
  // camera_resolution: yup.string().required("Camera Profile  is Required"),
  // .matches(resolutionRegex, "Camera Profile is invalid"),
  camera_details: yup.array().of(
    yup.object().shape({
      camera_model: yup
        .string()
        .required("Camera Model is Required")
        .max(100, "Camera Model should not exceed 100 characters"),
      camera_resolution: yup
        .string()
        .required("Camera Profile is Required")
        .max(100, "Camera Profile should not exceed 100 characters"),
    })
  ),
  video_story_telling: yup
    .string()
    .required("Format of Story telling is Required")
    .nullable(),
  sound_track: yup.string().required("Sound Track is Required").nullable(),

  sound_track_notes: yup
    .string()
    .when("sound_track", {
      is: "2",
      then: yup
        .string()
        .required("Notes is Required")
        .max(5000, "Notes should not exceed 5000 characters")
        .nullable(),
    })
    .nullable(),

  link_to_any_assets_used_previously: yup
    .string()
    .url("Please provide a valid url")
    .max(500, "Link to commonly used Assets should not exceed 500 characters")
    .nullable(),
  // .required("Link is Required"),

  // .matches(driveUrlRegex, "please provide a valid url"),

  percentage_of_luts: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Percentage is Required")
    .min(0, "Percentage can't be negative")
    .max(100, "Percentage is not more than 100")
    .nullable(),
  // size_of_logo: yup.string().required("Logo size is Required"),
  // position_of_logo_in_video: yup
  //   .string()
  //   .required("When is Required")
  //   .nullable(),
  // animation_of_logo: yup
  //   .string()
  //   .required("Animation logo is Required")
  //   .nullable(),
  // position_of_logo: yup.string().required("Position is Required").nullable(),
  // strat-ad
  client_speaking_language: yup
    .string()
    .required("Language spoken by your client is Required")
    .max(15, "Language spoken by your client should not exceed 15 characters"),
  most_used_nle: yup.string().required("NLE software is Required").nullable(),
  // end-ad
  prefered_font_name: yup
    .string()
    .required("Name of the Font is Required")
    .max(50, "The name of the font should not exceed 50 characters"),
  prefered_font_size: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .max(100, "Size of the Font is not more than 100")
    .min(1, "Size of the Font is not less than 1")
    .required("Size of the Font is Required"),
  prefered_font_character_spacing: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .max(1000, "Character Spacing is not more than 1000")
    .min(1, "Character Spacing is not less than 1")
    .required("Character Spacing is Required"),

  export_setting_codec: yup.string().required("codec is Required").nullable(),
  export_setting_compression: yup
    .string()
    .required("Compression is Required")
    .nullable(),
  export_setting_fps: yup.string().required("FPS is Required").nullable(),
  resolution: yup
    .string()
    .required("Resolution is Required")
    .matches(resolutionRegex, "Resolution is invalid")
    .max(20, "Character limit is 20"),
  reference_video_1: yup
    .string()
    .required("Reference video is Required")
    .max(500, "Reference Video should not exceed 500 characters"),
  reference_video_2: yup
    .string()
    .max(500, "Reference Video should not exceed 500 characters")
    .nullable(),
  reference_video_3: yup
    .string()
    .max(500, "Reference Video should not exceed 500 characters")
    .nullable(),
  profile_addtitional_note: yup
    .string()
    .max(5000, "Additional Notes should not exceed 5000 characters")
    .nullable(),
  privacy_policy: yup
    .string()
    .required("Privacy Policy is Required")
    .nullable(),
});

const EditStyleProfile = () => {
  const [disabledField, setDisabledField] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const getStyleProfile = useSelector((state) => state.styleProfile);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [deleteCamera, setDeleteCamera] = useState({
    open: false,
    index: null,
  });
  const [projectInfoModel, setProjectInfoModel] = useState(false);
  const styleProfile = localStorage.getItem("styleProfile");

  const userName = `${getStyleProfile?.styleProfile?.data?.first_name}
    ${getStyleProfile?.styleProfile?.data?.last_name}`;

  const {
    reset,
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const cameraDetails = useFieldArray({ control, name: "camera_details" });
  const soundTrack = watch("sound_track", false);

  const onSubmit = (data) => {
    const {
      // camera_model,
      // camera_resolution,
      camera_details,
      video_story_telling,
      sound_track,
      sound_track_notes,
      link_to_any_assets_used_previously,
      percentage_of_luts,
      lut_coloring,
      size_of_logo,
      position_of_logo_in_video,
      animation_of_logo,
      position_of_logo,
      prefered_font_name,
      // start-ad
      client_speaking_language,
      most_used_nle,
      // end-ad
      prefered_font_size,
      prefered_font_character_spacing,
      export_setting_codec,
      export_setting_compression,
      export_setting_fps,
      resolution,
      reference_video_1,
      reference_video_2,
      reference_video_3,
      profile_addtitional_note,
      privacy_policy,
    } = data;

    const values = {
      user_id: userData?.id,
      // camera_model,
      // camera_resolution,
      camera_details: JSON.stringify(camera_details),
      video_story_telling,
      sound_track,
      sound_track_notes,
      // start
      client_speaking_language,
      most_used_nle,
      // end
      link_to_any_assets_used_previously,
      percentage_of_luts,
      lut_coloring,
      size_of_logo,
      position_of_logo_in_video,
      animation_of_logo,
      position_of_logo,
      prefered_font_name,
      prefered_font_size,
      prefered_font_character_spacing,
      export_setting_codec,
      export_setting_compression,
      resolution,
      export_setting_fps,
      reference_video_1,
      reference_video_2,
      reference_video_3,
      profile_addtitional_note,
      privacy_policy,
    };

    dispatch(editProfileCreate(values));
  };

  //  radio button ref
  const { ref, ...rest } = register("privacy_policy", { required: true });
  const { ref: sound, ...soundrest } = register("sound_track", {
    required: true,
  });
  const { ref: storyTelling, ...storyTellingrest } = register(
    "video_story_telling",
    {
      required: true,
    }
  );

  const removeItem = (index) => {
    cameraDetails.remove(index);
    setDeleteCamera({ open: false, index: null });
  };

  useEffect(() => {
    if (location.pathname === ADMIN_ROUTES.STYLE_PROFILE_VIEW) {
      if (location?.state?.id) {
        if (location.state?.module) {
          dispatch(fetchProjectStyleProfile(location.state.id));
          setDisabledField(true);
        } else {
          dispatch(fetchStyleProfile(location.state.id));
          setDisabledField(true);
        }
      } else {
        navigate(ADMIN_ROUTES.PROJECT_MANAGEMENT);
      }
    } else {
      if (styleProfile === "0" || styleProfile === "null") {
        navigate(USER_ROUTES.STYLE_PROFILE);
      } else {
        dispatch(fetchStyleProfile(styleProfile));
      }
    }
  }, []);

  useEffect(() => {
    if (getStyleProfile?.styleProfile?.data) {
      const { data } = getStyleProfile.styleProfile;

      reset({
        camera_details: data.camera_details,
        // camera_model: data.camera_model,
        // camera_resolution: data.camera_resolution,
        video_story_telling: data.video_story_telling,

        sound_track: data.sound_track,
        sound_track_notes: data.sound_track_notes,
        link_to_any_assets_used_previously:
          data.link_to_any_assets_used_previously
            ? data.link_to_any_assets_used_previously
            : "",

        percentage_of_luts: data.percentage_of_luts,
        lut_coloring: data.lut_coloring,
        size_of_logo: data.size_of_logo,
        position_of_logo_in_video: data.position_of_logo_in_video,
        animation_of_logo: data.animation_of_logo,
        position_of_logo: data.position_of_logo,
        prefered_font_name: data.prefered_font_name,
        // strat-ad
        client_speaking_language: data.client_speaking_language,
        most_used_nle: data?.most_used_nle,
        // end-ad
        prefered_font_size: data.prefered_font_size,
        prefered_font_character_spacing: data.prefered_font_character_spacing,
        export_setting_codec: data.export_setting_codec,
        export_setting_compression: data.export_setting_compression,
        export_setting_fps: data.export_setting_fps,
        resolution: data.resolution,
        reference_video_1: data.reference_video_1,
        reference_video_2: data.reference_video_2,
        reference_video_3: data.reference_video_3,
        profile_addtitional_note: data.profile_addtitional_note
          ? data.profile_addtitional_note
          : "",
        privacy_policy: data.privacy_policy,
      });
    }
  }, [getStyleProfile.styleProfile.data]);

  if (getStyleProfile?.styleProfile?.isFetching) {
    return (
      <div>
        {[...Array(5)].map((_, i) => (
          <LineSkelaton key={i} />
        ))}
      </div>
    );
  }

  // state= getStyleProfile?.styleProfile?.id

  return (
    <>
      <div className="row justify-content-between align-items-center mb-2">
        <div className=" back-div col-lg-9 col-12">
          <div className="d-flex align-items-center">
            {disabledField && (
              <div className="">
                <Button
                  outline
                  color="primary"
                  className="back-btn me-1 rounded-pill p-50 "
                  onClick={() => navigate(ADMIN_ROUTES.PROJECT_MANAGEMENT)}
                >
                  <ArrowLeft id="arrow" />
                </Button>
              </div>
            )}
            <Breadcrumbs
              classname="breadcum"
              title={disabledField ? ` Style Profile` : "Edit Style Profile"}
              data={
                disabledField
                  ? [
                      {
                        title: `${userName}`,
                      },
                      {
                        title: ` Style Profile`,
                      },
                    ]
                  : [
                      {
                        title: "Edit Style Profile",
                      },
                    ]
              }
            />
          </div>
        </div>

        {!disabledField && (
          <>
            <div className="col-12 col-md-4 col-lg-3 text-start text-lg-end">
              <OrderButton
                setProjectInfoModel={setProjectInfoModel}
                projectInfoModel={projectInfoModel}
              />
            </div>
          </>
        )}
      </div>
      <UILoader blocking={getStyleProfile.isLoading} loader={<Loader />}>
        <Card>
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-1 ">
                <Col sm="12" className="mb-1">
                  <h4>Camera</h4>
                </Col>
                {cameraDetails.fields.map(({ id }, index) => {
                  const Div = index === 0 ? "div" : SlideDown;
                  return (
                    <Div key={id} className="repeater-wrapper">
                      <Row className="mb-1 align-items-center">
                        <Col xs={12} sm={12} md={5} className="mb-1">
                          <Label className="form-label">Camera Model</Label>

                          <Controller
                            id={`camera_model${index}`}
                            name={`camera_details.${index}.camera_model`}
                            control={control}
                            render={({ field }) => (
                              <Input
                                placeholder="Camera Model"
                                name={`camera_details.${index}.camera_model`}
                                disabled={disabledField}
                                {...field}
                              />
                            )}
                          />

                          {errors?.camera_details &&
                            errors.camera_details[index]?.camera_model && (
                              <FormFeedback>
                                {
                                  errors.camera_details[index]?.camera_model
                                    .message
                                }
                              </FormFeedback>
                            )}
                        </Col>
                        <Col xs={12} sm={12} md={5} className="mb-1">
                          <Label className="form-label">Camera Profile</Label>

                          <Controller
                            id={`camera_resolution${index}`}
                            name={`camera_details.${index}.camera_resolution`}
                            control={control}
                            render={({ field }) => (
                              <Input
                                placeholder="SLOG3"
                                name={`camera_details.${index}.camera_resolution`}
                                disabled={disabledField}
                                {...field}
                              />
                            )}
                          />
                          {errors?.camera_details &&
                            errors.camera_details[index]?.camera_resolution && (
                              <FormFeedback>
                                {
                                  errors.camera_details[index]
                                    ?.camera_resolution.message
                                }
                              </FormFeedback>
                            )}
                        </Col>
                        {/* <div className="mt-1 ps-2 d-flex align-items-center justify-content-center">
                        <Button
                          disabled={index === 0}
                          type="button"
                          className="action-btn"
                          onClick={() => cameraDetails.remove(index)}
                        >
                          <Trash2 size={18} className="cursor-pointer " />
                        </Button>
                      </div> */}
                        <Col xs={12} sm={12} md={2}>
                          {index === 0 || disabledField ? (
                            ""
                          ) : (
                            <Button.Ripple
                              className="btn-icon text-nowrap px-1"
                              color="danger"
                              disabled={index === 0}
                              outline
                              onClick={() =>
                                setDeleteCamera({ open: true, index })
                              } // Add this line to trigger deletion
                            >
                              <X size={14} className="me-50 cursor-pointer" />
                              <span>Delete</span>
                            </Button.Ripple>
                          )}
                        </Col>
                        <Col sm={12}>
                          <hr />
                        </Col>
                      </Row>
                    </Div>
                  );
                })}
                {disabledField ? (
                  ""
                ) : (
                  <>
                    <Col xs={12} className="mt-0">
                      <Button
                        // outline
                        disabled={disabledField}
                        color="gradient-primary"
                        onClick={() => {
                          if (cameraDetails.fields.length < 5) {
                            cameraDetails.append({
                              camera_model: "",
                              camera_resolution: "",
                            });
                          } else {
                            toast((t) => (
                              <ToastContent
                                t={t.id}
                                message="You have reached the maximum limit of 5 cameras and their camera profile"
                                color="danger"
                                icon={<X size={12} />}
                              />
                            ));
                          }
                        }}
                      >
                        <Camera size={14} className="me-50" />
                        <span className="align-middle ms-25">Add Camera</span>
                      </Button>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="mb-2">
                <Col sm="12">
                  <h4>Video Story Telling</h4>
                </Col>
                <Col>
                  <div className="demo-inline-spacing">
                    <div className="form-check form-check-inline">
                      <Input
                        innerRef={storyTelling}
                        {...storyTellingrest}
                        type="radio"
                        name="video_story_telling"
                        id="chronological"
                        value="chronological"
                        className="form-check-input"
                        disabled={disabledField}
                      />
                      <Label for="chronological" className="form-check-label">
                        Chronological
                      </Label>
                    </div>

                    <div className="form-check form-check-inline">
                      <Input
                        innerRef={storyTelling}
                        {...storyTellingrest}
                        type="radio"
                        name="video_story_telling"
                        id="nonchronologica"
                        value="non_chronological"
                        className="form-check-input"
                        disabled={disabledField}
                      />
                      <Label for="nonchronologica" className="form-check-label">
                        Non-Chronological
                      </Label>
                    </div>

                    {/* <div className="form-check form-check-inline">
                    <Input
                      innerRef={storyTelling}
                      {...storyTellingrest}
                      type="radio"
                      name="video_story_telling"
                      id="editingguide"
                      value="upload_your_editing_guide"
                      className="form-check-input"
                      disabled={disabledField}
                    />
                    <Label for="editingguide" className="form-check-label">
                      Upload your Editing Guide
                    </Label>
                  </div> */}
                    <div className="form-check form-check-inline">
                      <Input
                        innerRef={storyTelling}
                        {...storyTellingrest}
                        type="radio"
                        name="video_story_telling"
                        id="editingguide"
                        value="upload_your_editing_guide"
                        className="form-check-input"
                        disabled={disabledField}
                      />
                      <Tooltip
                        placement="top"
                        isOpen={tooltipOpen}
                        target="editingguide"
                        toggle={() => setTooltipOpen(!tooltipOpen)}
                      >
                        Add the Link of editing guide in Link to commonly used
                        Assets
                      </Tooltip>
                      <Label for="editingguide" className="form-check-label">
                        Upload your Editing Guide
                      </Label>
                    </div>
                  </div>
                  {errors.video_story_telling && (
                    <FormFeedback>
                      {errors.video_story_telling.message}
                    </FormFeedback>
                  )}
                </Col>
              </Row>
              {/* Start-AD */}
              <Row className="mb-1">
                <Col xl="6" lg="12" className="mb-1">
                  <Label>What language do your clients typically speak?</Label>
                  <Controller
                    defaultValue=""
                    control={control}
                    id="client_speaking_language"
                    name="client_speaking_language"
                    render={({ field }) => (
                      <Input
                        type="text"
                        placeholder="Enter Language"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.client_speaking_language && (
                    <FormFeedback>
                      {errors.client_speaking_language.message}
                    </FormFeedback>
                  )}
                </Col>
              </Row>
              {/* End-AD */}
              <Row className="mb-1">
                <Col sm="12">
                  <h4>Sound Track</h4>
                </Col>
                <Col className="mb-1">
                  <div className="demo-inline-spacing">
                    <div className="form-check form-check-inline">
                      <Input
                        innerRef={sound}
                        {...soundrest}
                        type="radio"
                        name="sound_track"
                        id="provideMusic"
                        value={1}
                        className="form-check-input"
                        disabled={disabledField}
                      />
                      <Label for="provideMusic" className="form-check-label">
                        I Will Provide The Music
                      </Label>
                    </div>

                    <div className="form-check form-check-inline">
                      <Input
                        innerRef={sound}
                        {...soundrest}
                        type="radio"
                        name="sound_track"
                        id="chooseMusic"
                        value={2}
                        className="form-check-input"
                        disabled={disabledField}
                      />
                      <Label for="chooseMusic" className="form-check-label">
                        Choose The Music For Me
                      </Label>
                    </div>
                  </div>
                  {errors.sound_track && (
                    <FormFeedback>{errors.sound_track.message}</FormFeedback>
                  )}
                </Col>
                {soundTrack === "2" && (
                  <div>
                    <Label for="sound_track_notes" className="form-check-label">
                      Music Notes
                    </Label>
                    <Controller
                      id="sound_track_notes"
                      name="sound_track_notes"
                      control={control}
                      render={({ field }) => (
                        <Input
                          type="textarea"
                          rows="3"
                          placeholder="Notes"
                          name="sound_track_notes"
                          disabled={disabledField}
                          {...field}
                        />
                      )}
                    />

                    {errors.sound_track_notes && (
                      <FormFeedback>
                        {errors.sound_track_notes.message}
                      </FormFeedback>
                    )}
                  </div>
                )}
              </Row>

              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Link to commonly used Assets</h4>
                </Col>
                <Col className="mb-1">
                  {disabledField ? (
                    <a
                      href={watch("link_to_any_assets_used_previously")}
                      target="_blank"
                    >
                      {watch("link_to_any_assets_used_previously")}
                    </a>
                  ) : (
                    <>
                      <Controller
                        id="link_to_any_assets_used_previously"
                        name="link_to_any_assets_used_previously"
                        control={control}
                        render={({ field }) => (
                          <Input
                            type="text"
                            placeholder="Add link of Dropbox or Google Drive folder containing any logo files, sound FX, light leaks, etc"
                            name="link_to_any_assets_used_previously"
                            disabled={disabledField}
                            {...field}
                          />
                        )}
                      />
                      {errors.link_to_any_assets_used_previously && (
                        <FormFeedback>
                          {errors.link_to_any_assets_used_previously.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Col>
              </Row>

              {/* Luts Related */}
              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>LUTs</h4>
                </Col>

                <Col sm="6" md="6" xl="6" xxl="6" xs="12" className="mb-1">
                  <Label>Percantage</Label>

                  <Controller
                    id="percentage_of_luts"
                    name="percentage_of_luts"
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="number"
                        placeholder="in Percentage(%)"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.percentage_of_luts && (
                    <FormFeedback>
                      {errors.percentage_of_luts.message}
                    </FormFeedback>
                  )}
                </Col>

                <Col xs="12" className="mb-1">
                  <Label>
                    Please provide any relevant coloring guidance here. If you
                    use a LUT, please tell us the name of it and include it in
                    your common asset folder
                  </Label>

                  <Controller
                    defaultValue=""
                    control={control}
                    id="lut_coloring"
                    name="lut_coloring"
                    render={({ field }) => (
                      <Input
                        type="text"
                        {...field}
                        maxLength={50}
                        disabled={disabledField}
                      />
                    )}
                  />
                </Col>
              </Row>

              {/* Upload File related */}

              {/* <Row className="mb-1">
              <Col sm="12" className="mb-1">
                <h4>Logo</h4>
              </Col>

              <Col sm="6" md="6" xl="6" xxl="6" xs="12" className="mb-1">
                <Label for="size">Size</Label>
                <Controller
                  id="size_of_logo"
                  name="size_of_logo"
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      placeholder="Input size in pt"
                      {...field}
                      disabled={disabledField}
                    />
                  )}
                />
                {errors.size_of_logo && (
                  <FormFeedback>{errors.size_of_logo.message}</FormFeedback>
                )}
              </Col>
              <Col sm="6" md="6" xl="6" xxl="6" xs="12" className="mb-1">
                <Label for="When">When</Label>

                <Controller
                  id="position_of_logo_in_video"
                  name="position_of_logo_in_video"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={whenOption}
                      theme={selectThemeColors}
                      className="react-select"
                      classNamePrefix="select"
                      // placeholder="when"
                      value={whenOption.find(
                        (row) =>
                          row.value === watch("position_of_logo_in_video")
                      )}
                      onChange={(e) => {
                        setValue("position_of_logo_in_video", e.value);
                      }}
                      isDisabled={disabledField}
                    />
                  )}
                />
                {errors.position_of_logo_in_video && (
                  <FormFeedback>
                    {errors.position_of_logo_in_video.message}
                  </FormFeedback>
                )}
              </Col>
              <Col sm="6" md="6" xl="6" xxl="6" xs="12" className="mb-1">
                <Label>Animation</Label>

                <Controller
                  id="animation_of_logo"
                  name="animation_of_logo"
                  control={control}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={animationOption}
                        theme={selectThemeColors}
                        className="react-select"
                        classNamePrefix="select"
                        // placeholder="Animation"
                        value={animationOption.find(
                          (row) => row.value === watch("animation_of_logo")
                        )}
                        onChange={(e) => {
                          setValue("animation_of_logo", e.value);
                        }}
                        isDisabled={disabledField}
                      />
                    );
                  }}
                />
                {errors.animation_of_logo && (
                  <FormFeedback>
                    {errors.animation_of_logo.message}
                  </FormFeedback>
                )}
              </Col>
              <Col sm="6" md="6" xl="6" xxl="6" xs="12" className="mb-1">
                <Label>Position</Label>

                <Controller
                  id="position_of_logo"
                  name="position_of_logo"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={positionOption}
                      theme={selectThemeColors}
                      className="react-select"
                      classNamePrefix="select"
                      // placeholder="Positioning"
                      value={positionOption.find(
                        (row) => row.value === watch("position_of_logo")
                      )}
                      onChange={(e) => {
                        setValue("position_of_logo", e.value);
                      }}
                      isDisabled={disabledField}
                    />
                  )}
                />
                {errors.position_of_logo && (
                  <FormFeedback>{errors.position_of_logo.message}</FormFeedback>
                )}
              </Col>
            </Row> */}

              {/* Font Related */}

              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Fonts</h4>
                </Col>
                <Col sm="4" xs="12" md="4" xxl="4" xl="4" className="mb-1">
                  <Label>Name of the Font</Label>
                  <Controller
                    defaultValue=""
                    control={control}
                    id="prefered_font_name"
                    name="prefered_font_name"
                    render={({ field }) => (
                      <Input
                        type="text"
                        placeholder="Name of the Font"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.prefered_font_name && (
                    <FormFeedback>
                      {errors.prefered_font_name.message}
                    </FormFeedback>
                  )}
                </Col>
                <Col sm="4" xs="12" md="4" xxl="4" xl="4" className="mb-1">
                  <Label>Size of the Font</Label>
                  <Controller
                    defaultValue=""
                    control={control}
                    id="prefered_font_size"
                    name="prefered_font_size"
                    render={({ field }) => (
                      <Input
                        type="number"
                        placeholder="Size of the Font"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.prefered_font_size && (
                    <FormFeedback>
                      {errors.prefered_font_size.message}
                    </FormFeedback>
                  )}
                </Col>
                <Col sm="4" xs="12" md="4" xxl="4" xl="4" className="mb-1">
                  <Label>Character Spacing</Label>
                  <Controller
                    defaultValue=""
                    control={control}
                    id="prefered_font_character_spacing"
                    name="prefered_font_character_spacing"
                    render={({ field }) => (
                      <Input
                        type="number"
                        placeholder="Character Spacing"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.prefered_font_character_spacing && (
                    <FormFeedback>
                      {errors.prefered_font_character_spacing.message}
                    </FormFeedback>
                  )}
                </Col>
              </Row>

              {/* Export Setting Related */}

              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Export Settings</h4>
                </Col>
                <Col sm="3" xs="12" md="3" xxl="3" xl="3" className="mb-1">
                  <Label className="form-label" for="InputHelp">
                    Codec
                  </Label>

                  <Controller
                    id="export_setting_codec"
                    name="export_setting_codec"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={codecOption}
                        theme={selectThemeColors}
                        className="react-select"
                        classNamePrefix="select"
                        // placeholder="Codec"
                        value={codecOption.find(
                          (row) => row.value === watch("export_setting_codec")
                        )}
                        onChange={(e) => {
                          setValue("export_setting_codec", e.value);
                        }}
                        isDisabled={disabledField}
                      />
                    )}
                  />
                  {errors.export_setting_codec && (
                    <FormFeedback>
                      {errors.export_setting_codec.message}
                    </FormFeedback>
                  )}
                </Col>
                <Col sm="3" xs="12" md="3" xxl="3" xl="3" className="mb-1">
                  <Label className="form-label" for="InputHelp">
                    Compression
                  </Label>

                  <Controller
                    id="export_setting_compression"
                    name="export_setting_compression"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={compressionOption}
                        theme={selectThemeColors}
                        className="react-select"
                        classNamePrefix="select"
                        // placeholder="Compression"
                        value={compressionOption.find(
                          (row) =>
                            row.value === watch("export_setting_compression")
                        )}
                        onChange={(e) => {
                          setValue("export_setting_compression", e.value);
                        }}
                        isDisabled={disabledField}
                      />
                    )}
                  />
                  {errors.export_setting_compression && (
                    <FormFeedback>
                      {errors.export_setting_compression.message}
                    </FormFeedback>
                  )}
                </Col>
                <Col sm="3" xs="12" md="3" xxl="3" xl="3" className="mb-1">
                  <Label className="form-label" for="InputHelp">
                    FPS
                  </Label>

                  <Controller
                    id="export_setting_fps"
                    name="export_setting_fps"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={framesOption}
                        theme={selectThemeColors}
                        className="react-select"
                        classNamePrefix="select"
                        // placeholder="Frames Per Second"
                        value={framesOption?.find(
                          (row) => row.value === watch("export_setting_fps")
                        )}
                        onChange={(e) => {
                          setValue("export_setting_fps", e.value);
                        }}
                        isDisabled={disabledField}
                      />
                    )}
                  />
                  {errors.export_setting_fps && (
                    <FormFeedback>
                      {errors.export_setting_fps.message}
                    </FormFeedback>
                  )}
                </Col>

                <Col sm="3" xs="12" md="3" xxl="3" xl="3" className="mb-1">
                  <Label>Resolution</Label>
                  <Controller
                    id="resolution"
                    name="resolution"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="text"
                        placeholder="1080 x 1920 px"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.resolution && (
                    <FormFeedback>{errors.resolution.message}</FormFeedback>
                  )}
                </Col>
              </Row>

              {/* Start-AD */}
              <Row className="mb-1">
                <Col xl="8" lg="12" className="mb-1">
                  <Label className="form-label" for="InputHelp">
                    Which NLE software do you use most? We currently only use
                    Premiere, but this information is helpful to us in planning
                    for the future so we can better serve you
                  </Label>
                  <Controller
                    id="most_used_nle"
                    name="most_used_nle"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={NELOption}
                        theme={selectThemeColors}
                        className="react-select"
                        classNamePrefix="select"
                        // placeholder="Codec"
                        value={NELOption.find(
                          (row) => row.value === watch("most_used_nle")
                        )}
                        onChange={(e) => {
                          setValue("most_used_nle", e.value);
                        }}
                        isDisabled={disabledField}
                      />
                    )}
                  />
                  {errors.most_used_nle && (
                    <FormFeedback>{errors.most_used_nle.message}</FormFeedback>
                  )}
                </Col>
              </Row>
              {/* End-AD */}

              {/* Refrence Video */}
              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Refrence Videos</h4>
                </Col>
                <Col sm="12" className="mb-1">
                  {disabledField ? (
                    <a href={watch("reference_video_1")} target="_blank">
                      {watch("reference_video_1")}
                    </a>
                  ) : (
                    <>
                      <Controller
                        control={control}
                        id="reference_video_1"
                        name="reference_video_1"
                        render={({ field }) => (
                          <Input
                            type="url"
                            placeholder="Add Link for Refrence Video"
                            {...field}
                            disabled={disabledField}
                          />
                        )}
                      />
                      {errors.reference_video_1 && (
                        <FormFeedback>
                          {errors.reference_video_1.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Col>
                <Col sm="12" className="mb-1">
                  {disabledField ? (
                    <a href={watch("reference_video_2")} target="_blank">
                      {watch("reference_video_2")}
                    </a>
                  ) : (
                    <>
                      <Controller
                        control={control}
                        id="reference_video_2"
                        name="reference_video_2"
                        render={({ field }) => (
                          <Input
                            type="url"
                            placeholder="Add Link for Refrence Video"
                            {...field}
                            disabled={disabledField}
                          />
                        )}
                      />
                      {errors.reference_video_2 && (
                        <FormFeedback>
                          {errors.reference_video_2.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Col>
                <Col sm="12" className="mb-1">
                  {disabledField ? (
                    <a href={watch("reference_video_3")} target="_blank">
                      {watch("reference_video_3")}
                    </a>
                  ) : (
                    <>
                      <Controller
                        control={control}
                        id="reference_video_3"
                        name="reference_video_3"
                        render={({ field }) => (
                          <Input
                            type="url"
                            placeholder="Add Link for Refrence Video"
                            {...field}
                            disabled={disabledField}
                          />
                        )}
                      />
                      {errors.reference_video_3 && (
                        <FormFeedback>
                          {errors.reference_video_3.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                </Col>
              </Row>

              {/* Additional Notes */}
              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Additional Notes</h4>
                </Col>
                <Col sm="12" className="mb-1">
                  <Controller
                    control={control}
                    id="profile_addtitional_note"
                    name="profile_addtitional_note"
                    render={({ field }) => (
                      <Input
                        rows={10}
                        type="textarea"
                        placeholder="Additional Notes"
                        {...field}
                        disabled={disabledField}
                      />
                    )}
                  />
                  {errors.profile_addtitional_note && (
                    <FormFeedback>
                      {errors.profile_addtitional_note.message}
                    </FormFeedback>
                  )}
                </Col>
              </Row>

              {/* Privacy Policy */}
              <Row className="mb-1">
                <Col sm="12" className="mb-1">
                  <h4>Privacy Policy</h4>
                  <div className="mb-1">
                    {/* <p>
                    <b>Note: </b>Privacy is of the utmost importance to us, We
                    would like to ask your permission for using your video in
                    our promotional campaigns
                  </p> */}

                    <p>
                      <b>Note: </b>Your privacy is of the utmost importance to
                      us. As such, we would like to ask your permission to use
                      your video(s) in our promotional materials (social media,
                      website, marketing emails, etc)
                    </p>
                  </div>
                </Col>
                <Col xl="3" xxl="3" md="3" sm="6" xs="4" className="mb-1">
                  <div className="form-check form-check-inline">
                    <Input
                      innerRef={ref}
                      {...rest}
                      type="radio"
                      name="privacy_policy"
                      id="yes"
                      value={1}
                      className="form-check-input"
                      maxLength={200}
                      disabled={disabledField}
                    />

                    <Label for="yes" className="form-check-label">
                      Yes
                    </Label>
                  </div>
                </Col>

                <Col xl="3" xxl="3" md="3" sm="6" xs="4" className="mb-1">
                  <div className="form-check form-check-inline">
                    <Input
                      innerRef={ref}
                      {...rest}
                      type="radio"
                      name="privacy_policy"
                      id="ask_us"
                      value={2}
                      className="form-check-input"
                      disabled={disabledField}
                    />

                    <Label for="ask_us" className="form-check-label">
                      Ask us first
                    </Label>
                  </div>
                </Col>

                <Col xl="3" xxl="3" md="3" sm="6" xs="4" className="mb-1">
                  <div className="form-check form-check-inline">
                    <Input
                      innerRef={ref}
                      {...rest}
                      type="radio"
                      name="privacy_policy"
                      id="No"
                      value={3}
                      className="form-check-input"
                      disabled={disabledField}
                    />

                    <Label for="No" className="form-check-label">
                      No
                    </Label>
                  </div>
                </Col>
                {errors.privacy_policy && (
                  <FormFeedback>{errors.privacy_policy.message}</FormFeedback>
                )}
              </Row>
              {disabledField ? (
                ""
              ) : (
                <div className="d-flex">
                  <Button
                    className="me-1"
                    color="primary"
                    type="submit"
                    disabled={getStyleProfile.isLoading || disabledField}
                  >
                    Submit
                  </Button>
                  {/* <Button outline color="secondary" type="reset">
                Reset
              </Button> */}
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </UILoader>

      <ConfirmModel
        btnColor="danger"
        primaryBtnTitle="Delete"
        handleClick={() => {
          removeItem(deleteCamera.index);
          setDeleteCamera((prev) => ({ ...prev, open: false }));
        }}
        secondaryBtnText="Cancel"
        open={deleteCamera?.open}
        setOpen={setDeleteCamera}
        handleClose={() =>
          setDeleteCamera((prev) => ({ ...prev, open: false }))
        }
        title="Are You Sure you want to Delete?"
      />

      {projectInfoModel && (
        <CreateProjectInfoModel
          show={projectInfoModel}
          setShow={setProjectInfoModel}
        />
      )}
    </>
  );
};

export default EditStyleProfile;
